export default "__VITE_ASSET__f2ELcw$R__"